// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Ts0f","select":"Header_select__3F_-b","clinic":"Header_clinic__2c7lm"};